import React from 'react';
import ReactEcharts from 'echarts-for-react';

const Spareline = ({ data }) => {
    // Month number to name mapping
    const monthMap = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec',
    };

    // Ensure data is valid
    const xData = Array.isArray(data)
        ? data.map(item => monthMap[item.key] || item.key)
        : [];

    const yData = Array.isArray(data)
        ? data.map(item => item.doc_count)
        : [];

    const option = {
        tooltip: {
            trigger: 'axis',
        },
        xAxis: {
            type: 'category',
            data: xData,
            splitLine: { show: false }, // ❌ Remove vertical grid lines

        },
        yAxis: {
            type: 'value',
            splitLine: { show: false }, // ❌ Remove vertical grid lines

        },
        series: [
            {
                data: yData,
                type: 'line',
                smooth: true,
                itemStyle: {
                    color: '#4A90E2',
                },
                lineStyle: {
                    width: 2,
                },
            },
        ],
    };

    return (
        <div>
            <ReactEcharts option={option} style={{ width: "100%", height: 320, marginLeft: "3px", marginTop: "4px" }} />
        </div>
    );
};

export default Spareline;
